import { observer } from "mobx-react-lite";
import { FC, useCallback } from "react";
import { googleIdentityModule } from "@/modules/google-identity";
import { AuthCardSignUpWithGoogleButton } from "@/components/auth/google/AuthCardSignUpWithGoogleButton";
import { AuthCardBase } from "@/components/auth/AuthCardBase";

export interface AuthCardSignUpProps {}

export const AuthCardSignUp: FC<AuthCardSignUpProps> = observer(() => {
  const signUpWithGoogle = useCallback(async () => await googleIdentityModule.triggerSignUp(), []);

  return (
    <AuthCardBase>
      <AuthCardSignUpWithGoogleButton onClick={signUpWithGoogle} />
    </AuthCardBase>
  );
});
